import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import BasePersonalDataForm from "../base-personal-data-form";
import StayDataForm from "../stay-data-form";
import ConfirmButton from "../confirm-button";
import ChooseExperience from "../choose-experience";
import ExperienceDataForm from "../experience-data-form";
import Summary from "../price/summary";
import LargeDivisor from "../large-divisor";
import Notes from "../notes";
import {
  pick,
  GuestsType,
  DateType,
  experiencePropType,
  numSelectedExperiencesGuestsPropType
} from "../../model/utils";
import Confirmation from "../confirmation";
import {
  sendMail,
  setReservationType,
  startup,
  focusOn
} from "../../store/actions";
import Title from "../titles/title";
import ConfirmationHeader from "../titles/confirmation-header";

const mapDispatchToProps = dispatch => ({
  sendMail: sendMailOptions => dispatch(sendMail(sendMailOptions)),
  sendType: () => dispatch(setReservationType("room")),
  start: () => dispatch(startup()),
  focusOn: fieldName => dispatch(focusOn(fieldName))
});

const inputFieldStart = "input-field-name-";

const ReserveRoomForm = props => {
  const {
    selectedExperiences,
    roomReservationValid,
    sendMail,
    sendType,
    start,
    focusOn
  } = props;

  const onConfirm = () => sendMail(props);

  React.useEffect(() => {
    start();
    sendType();
  }, [sendType, start]);

  // when we click somewhere, we could focus away from some other element.
  const onClick = React.useCallback(
    ev => {
      let currentElement = ev.target;
      while (
        !!currentElement &&
        (currentElement.id || "").indexOf(inputFieldStart) !== 0
      ) {
        currentElement = currentElement.parentNode;
      }
      if (!currentElement) {
        console.log("Clicked on no element.");
        focusOn(null);
      } else {
        console.log("Clicked on", currentElement);
        focusOn(currentElement.id.substring(inputFieldStart.length));
      }
    },
    [focusOn]
  );

  return (
    <div style={{ color: "#171717", width: "100%" }} onClick={onClick}>
      {props.status === "input" ? (
        <>
          <Title stringKey="roomTitle" />
          <BasePersonalDataForm />
          <StayDataForm />
          <ChooseExperience />
          {(selectedExperiences || []).map(experience => (
            <ExperienceDataForm key={experience.id} experience={experience} />
          ))}
          <LargeDivisor />
          <Summary />
          <LargeDivisor />
          <Notes includeReservedTableNote />
          <ConfirmButton disabled={!roomReservationValid} onClick={onConfirm} />
        </>
      ) : props.status === "sending-mail" ? (
        <div>Sending...</div>
      ) : (
        <>
          <ConfirmationHeader />
          <Title stringKey="confirmationTitle" />
          <Confirmation />
        </>
      )}
    </div>
  );
};

ReserveRoomForm.propTypes = {
  selectedExperiences: PropTypes.arrayOf(experiencePropType.isRequired),
  roomReservationValid: PropTypes.bool,
  sendMail: PropTypes.func.isRequired,
  sendType: PropTypes.func.isRequired,
  start: PropTypes.func.isRequired,
  status: PropTypes.string,
  name: PropTypes.string,
  surname: PropTypes.string,
  country: PropTypes.string,
  postcode: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  numRoomGuests: GuestsType,
  roomKind: PropTypes.object,
  hasExperience: PropTypes.bool,
  numSelectedExperiencesGuests: numSelectedExperiencesGuestsPropType,
  roomDates: DateType,
  notes: PropTypes.string,
  experienceDate: DateType,
  experienceTime: PropTypes.string,
  experiencePrice: PropTypes.number,
  roomPrice: PropTypes.number,
  focusOn: PropTypes.func.isRequired
};

export default connect(
  pick([
    "country",
    "dateRanges",
    "numNights",
    "email",
    "experiencePrice",
    "experienceReservationValid",
    "experiencesDates",
    "experiencesPrices",
    "experiencesTimes",
    "focusedField",
    "hasExperience",
    "hasRoomKind",
    "name",
    "notes",
    "numRoomGuests",
    "numSelectedExperiencesGuests",
    "phoneNumber",
    "postcode",
    "reservationType",
    "roomDates",
    "roomKind",
    "roomPrice",
    "roomReservationValid",
    "selectedExperiences",
    "status",
    "surname"
  ]),
  mapDispatchToProps
)(ReserveRoomForm);
